<template>
  <v-container
    fluid
    class="sign-form"
  >
    <v-row>
      <v-col
        sm="12"
        md="4"
        cols="12"
      >
        <v-card
          align="center"
          class="login-card"
        >
          <a
            href="/"
            title="Britecheck.com"
          >
            <img
              class="logo-img"
              src="@/assets/images/logo-britecheck.svg"
              width="220"
              height="36"
              alt="Britecheck"
            >
          </a>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="login-main">
      <v-col
        sm="12"
        md="12"
        cols="12"
      >
        <v-row justify="center">
          <v-col
            sm="12"
            md="12"
            cols="12"
            style="padding: unset"
          >
            <v-card-subtitle align="center">
              <h1 class="login-subtitle">
                Sign In
              </h1>
            </v-card-subtitle>
            <v-card-text
              align="center"
              class="login-welcome"
            >
              Don't have an account yet?
              <a
                depressed
                class="link-sign"
                @click="$router.push({ name: 'Register' })"
              >Sign Up Now</a>
            </v-card-text>
          </v-col>
        </v-row>
        <v-row
          justify="center"
          class="login-container"
        >
          <v-col
            sm="12"
            md="5"
            lg="4"
            cols="12"
          >
            <v-card
              align="center"
              class="login-card"
            >
              <LoginForm class="login-form" />
            </v-card>
          </v-col>
          <v-col
            sm="12"
            md="5"
            lg="4"
            cols="12"
          >
            <v-card class="login-card">
              <div class="social_block_sign">
                <div
                  class="social-button"
                  style="display: none !important;"
                >
                  <v-btn class="button_login_new fb_button_login_new">
                    <div class="buttonIcon">
                      <div class="buttonSvgImage" />
                    </div>
                    <span class="button_login_new__text">Sign In with Facebook</span>
                  </v-btn>
                </div>
                <div class="social-button">
                  <a
                    href="/auth/google"
                    class="button_login_new google_button_login_new"
                  >
                    <div class="buttonIcon">
                      <div class="buttonSvgImage" />
                    </div>
                    <span class="button_login_new__text">Sign In with Google</span>
                  </a>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col
            sm="12"
            md="12"
            cols="12"
            style="padding: unset"
          >
            <v-card
              align="center"
              class="login-card"
            >
              <v-card-text class="text-center terms-policy">
                By signing in you agree to our <span class="text-nowrap"><a
                  class="subtitle-2"
                  href="privacy-policy.html"
                >Privacy policy</a> & <a
                  class="subtitle-2"
                  href="terms-of-use.html"
                >Term of use</a>.</span>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LoginForm from '@/components/user/LoginForm'
export default {
  name: 'Login',
  components: {
    LoginForm
  },
  metaInfo: {
    title: 'Login to Your Inventory Management Dashboard',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'Access your inventory management tools. Log in to track stock, optimize inventory, and streamline your small business operations'
      }
    ]
  },
  mounted() {
    if (!localStorage.getItem('curUserData') && !!localStorage.getItem('querytoken')) {
      this.$store.dispatch('user/getUserByToken', localStorage.getItem('querytoken')).then((response) => {
        if (response) {
          localStorage.removeItem('querytoken')
          this.$router.go('/inventory')
        }
      })
    }
  }
}
</script>

<style lang="scss">
.body--light {
  background: whitesmoke;
}
.login-container {
  position: relative;
  &:after {
    content: '';
    display: block;
    width: 1px;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.1);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    @media screen and (max-width: 1023px) {
      display: none;
    }
  }
}
.sign-form {
  background-color: #f5f5f5 !important;
  min-height: 100vh;
}
.link-sign {
  color: #7671bd;
  transition: 0.3s;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
    transition: 0.3s;
  }
}
.sign-img .v-image__image--cover {
  background-size: 100% !important;
}
.subtitle-2 {
  text-decoration: none;
}
.login-card {
  height: 100%;
  margin: unset;
  border-radius: unset !important;
  background-color: #f5f5f5 !important;
  box-shadow: none !important;
  @media screen and (max-width: 768px) {
    padding-left: 2px;
    padding-right: 2px;
  }
}
.login-form {
  background-color: #f5f5f5 !important;
  .v-input--selection-controls, .forgot-link {
    @media screen and (max-width: 468px) {
      margin-top: 0;
      padding-top: 0;
    }
  }
}
.v-text-field > .v-input__control > .v-input__slot:after {
  border-color: #7671bd !important;
}
</style>
